import { render } from "./TwBreadcrumbs.vue?vue&type=template&id=8dc2c8b6"
import script from "./TwBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./TwBreadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__